import React, { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Switch } from '../ui/switch';
import RichTextEditor from './RichTextEditor';
import SharedFieldRow from './SharedFieldRow';
import { SHARED_SECTIONS } from './SharedSectionsCard';
import { getSharedJobFields } from '../../api';

const CLEARANCE_LEVELS = ['None', 'Public Trust', 'Secret', 'Top Secret', 'TS/SCI', 'TS/SCI w/ Poly'];
const JOB_TYPES = ['Full-time', 'Part-time', 'Contract', 'Internship'];

const JobForm = ({ job, onChange }) => {
  const setField = (k, v) => onChange({ ...job, [k]: v });
  const [shared, setShared] = useState(null);
  useEffect(() => { getSharedJobFields().then(setShared).catch(() => setShared({})); }, []);
  return (
    <div className="grid gap-4">
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label className="text-slate-300 text-xs mb-1.5 block">Title</Label><Input value={job.title} onChange={e => setField('title', e.target.value)} className="bg-[#080d18] border-slate-700 focus:border-cyan-400 text-white" /></div>
        <div><Label className="text-slate-300 text-xs mb-1.5 block">Department / Tag</Label><Input value={job.tag} onChange={e => setField('tag', e.target.value)} className="bg-[#080d18] border-slate-700 focus:border-cyan-400 text-white" /></div>
      </div>
      <div><Label className="text-slate-300 text-xs mb-1.5 block">Description</Label><RichTextEditor testId="job-description" value={job.description} onChange={v => setField('description', v)} /></div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label className="text-slate-300 text-xs mb-1.5 block">Location</Label><Input value={job.location} onChange={e => setField('location', e.target.value)} className="bg-[#080d18] border-slate-700 focus:border-cyan-400 text-white" /></div>
        <div>
          <Label className="text-slate-300 text-xs mb-1.5 block">Type</Label>
          <Select value={job.type} onValueChange={v => setField('type', v)}>
            <SelectTrigger className="bg-[#080d18] border-slate-700 text-white"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[#0d1424] border-slate-700 text-white">
              {JOB_TYPES.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label className="text-slate-300 text-xs mb-1.5 block">Requirements</Label><RichTextEditor testId="job-requirements" value={job.requirements} onChange={v => setField('requirements', v)} /></div>
        <div><Label className="text-slate-300 text-xs mb-1.5 block">Certifications</Label><RichTextEditor testId="job-certifications" value={job.certifications} onChange={v => setField('certifications', v)} /></div>
      </div>
      <div className="grid gap-4 rounded-lg border border-cyan-400/10 p-4">
        {SHARED_SECTIONS.map(sec => <SharedFieldRow key={sec.key} field={sec.key} label={sec.label} job={job} shared={shared} onChange={onChange} />)}
      </div>
      <div className="grid sm:grid-cols-2 gap-3 items-end">
        <div>
          <Label className="text-slate-300 text-xs mb-1.5 block">Clearance Level</Label>
          <Select value={job.clearance_level} onValueChange={v => setField('clearance_level', v)}>
            <SelectTrigger className="bg-[#080d18] border-slate-700 text-white"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[#0d1424] border-slate-700 text-white">
              {CLEARANCE_LEVELS.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="flex flex-col gap-3 pb-2">
          <div className="flex items-center gap-3"><Switch checked={!!job.active} onCheckedChange={v => setField('active', v)} /><span className="text-slate-300 text-sm">Active (visible on public site)</span></div>
          <div className="flex items-center gap-3"><Switch checked={!!job.is_hot} onCheckedChange={v => setField('is_hot', v)} /><span className="text-slate-300 text-sm">Hot job (shows flame icon)</span></div>
        </div>
      </div>
    </div>
  );
};

export default JobForm;
